import anime from 'animejs';

export default class Hero {

    constructor() {
        /**
         * Hero blob animation
         */
		var heroValues = 'M915.751531,467.003722 C817.804592,307.427462 1181.67398,160.616141 1136.01582,-33.6784229 C1086.08265,-246.029994 718.37449,-388.683261 507.3,-244.721515 C296.22551,-100.759769 320.654082,-9.60241288 241.144898,107.811752 C146.542347,247.440979 -38.8239796,338.133098 11.3709184,532.049657 C61.5658163,725.995293 479.643367,968.907113 806.957143,807.237288 C910.255102,756.177537 1007.09694,615.879532 915.751531,467.003722 Z';
		if ($("body").hasClass("junior")) {
			heroValues = 'M0,300a500,500 0 1,0 1000,0a500,500 0 1,0 -1000,0';
			$("#hero__blob__mask path").attr("d",'M0,200a200,200 0 1,0 400,0a200,200 0 1,0 -400,0');
		}
		 
        anime({
            targets: '#hero__blob__mask path',
            d: [{
                value: heroValues
            }],
            easing: 'easeOutQuad',
            duration: 700,
            loop: false
        });


        let jsHeroIcon = false;
        $('.js-hero-icon').on('click', function () {

            let jsHeroIconToggleSelector = '.hero__header, .hero__text, .hero__icon:not(.js-hero-icon), .hero__icon--selected div';

            if (!jsHeroIcon) {
                document.querySelector("image").setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', $(this).data('src'));

                $(this).toggleClass('hero__icon--selected');

                anime({
                    targets: jsHeroIconToggleSelector,
                    opacity: 0,
                    easing: 'easeOutQuad',
                    duration: 700,
                    loop: false
                });

                anime({
                    targets: '.hero__blob image',
                    opacity: 1,
                    easing: 'easeOutQuad',
                    duration: 700,
                    loop: false
                });

                jsHeroIcon = true;
            } else {

                anime({
                    targets: jsHeroIconToggleSelector,
                    opacity: 1,
                    easing: 'easeOutQuad',
                    duration: 700,
                    loop: false
                });

                anime({
                    targets: '.hero__blob image',
                    opacity: 0,
                    easing: 'easeOutQuad',
                    duration: 700,
                    loop: false
                });

                $(this).removeClass('hero__icon--selected');

                jsHeroIcon = false;
            }

        });

    }
}